// 参考：https://zenn.dev/longbridge/articles/f23ebecd5ad953
import * as yup from 'yup';
import { AnyObject, Maybe } from 'yup/lib/types';

declare module 'yup' {
  interface StringSchema<
    TType extends Maybe<string> = string | undefined,
    TContext extends AnyObject = AnyObject,
    TOut extends TType = TType
  > extends yup.BaseSchema<TType, TContext, TOut> {
    half(): StringSchema<TType, TContext>;
    date(): StringSchema<TType, TContext>;
  }
}

export default yup;
